export default {
    myBirthChart: 'Meu Mapa Astral',

    resume: {
        titleResume: '<span class="h4">Resumo do seu mapa astral</span>',
        titleCard: '{planet} <small>em</small> <br> <strong class={signClass}>{sign}</strong>',
        noSignTitleCard: '<a href="/my-profile?area=nascimento" class="noSignTitle">Informe seu <br>horário de <br>nascimento</a>',
        decant: '{decant}º decanato',
        callToAction: 'Ver Mapa Completo',
        errorMessage: 'Não foi possível carregar o resumo do mapa astral',
        link: 'mapa-astral',
    },

    energy: {
        elementsTitle: 'Elementos',
        qualitiesTitle: 'Qualidades',
        polaritiesTitle: 'Polarização Energética',
        yang: 'Yang | Ativo',
        yin: 'Yin | Reativo',
        cardinal: 'Cardinal',
        fixed: 'Fixo',
        mutable: 'Mutável',
        qualities: {
            cardinal: 'Cardinal',
            fixed: 'Fixo',
            mutable: 'Mutável'
        },

        polarities: {
            yin: 'Yin',
            yang: 'Yang'
        },

        elements: {
            water: 'Água',
            earth: 'Terra',
            air: 'Ar',
            fire: 'Fogo'
        },

        errorMessage: 'Não foi possível carregar a distribuição energética',
        whatIs: 'O que são?',
        modalElements: { 
            text : 'Todos nós incorporamos os 4 elementos de alguma forma em nossas vidas. Estamos de pé sobre a <strong>Terra</strong> e dela tiramos parte do nosso sustento. As informações ao nosso redor apelam para o nosso intelecto, som e verbo, invocando o elemento <strong>Ar</strong>. Nossas ações são regidas pelo domínio do <strong>Fogo</strong>, com sua vontade, iniciativa e energia, enquanto as emoções desencadeadas pelas nossas experiências invocam o elemento <strong>Água</strong>, o mais fluido.<br /><br /> O ser humano experimenta todos os elementos desde sua concepção: quando imerso no líquido amniótico (água), na formação do corpo material (terra), ao ligar a chave dos batimentos cardíacos e impulsos elétricos (fogo) e fazendo valer seus pulmões com a primeira inação de oxigênio e emissão sonora (ar). Para alcançar o equilíbrio, precisamos compreender, honrar e melhorar nossas características pessoais reconhecendo a influnêcia dos 4 elementos em nossas vidas.',
            title : 'Os 4 Elementos<small><p>Fogo, Terra, Ar e Água.</p></small>',
            button : 'Aprender mais sobre os 4 elementos',
            article : 'elementos'
        },

        modalQualities: { 
            text : 'Os 4 elementos, que formam a espinha dorsal do estudo da Astrologia, podem ser expressados em diferentes variações. A primeira é a divisão dos 12 signos pelos 4 elementos, que é chamada de <strong>triplicidade</strong>, ou seja, para cada elemento, teremos um grupo de 3 signos.<br /><br />A segunda é a divisão dos 12 signos pelas 3 expressões desses elementos, onde o resultado é chamado de <strong>quadruplicidade</strong> - ou qualidades, modos. Assim, teremos um grupo de 4 signos para cada expressão. Cada um dos quatro elementos irá apresentar uma expressão <strong>cardinal</strong>, uma expressão <strong>fixa</strong> e uma expressão <strong>mutável</strong>.',
            title : 'As Qualidades<small><p>Ou modalidades dos signos</p></small>',
            button : 'Aprender mais sobre as qualidades',
            article : 'qualidades'
        },

        modalPolarities: { 
            text : 'As polaridades dividem o círculo do Zodíaco em dois grupos distintos de seis signos cada, que são categorizados como Masculinos (Ativos, Yang, Direcionados para fora) e Femininos (Passivos, Yin, Direcionados para dentro).<br /><br />O conceito do yin-yang se expressa amplamente nas polaridades diversas, nas dicotomias universais como ação e reação, luz e escuridão, frio e calor, nos movimentos de inspiração e expiração, nas forças centrífuga e centrípeta, etc. Tudo sempre constitui duas metades a serem completadas, como o espírito e a matéria, o subjetivo e objetivo, o interior e o exterior, o movimento e repouso. Os extremos se complementam para que exista um equilíbrio universal entre todas as coisas.',
            title : 'A Polarização Energética<small><p>ativo e reativo</p></small>',
            button : 'Aprender mais sobre as polaridades',
            article : 'polaridades'
        },
    }
}